import React from "react";

export const BUTTON_LABELS = {
  OK: "OK",
  DELETE: "Delete",
  CANCEL: "Cancel",
  UPLOAD: "Upload",
};

export const ACTIVATION_PROFILES_WARNING_MESSAGE_SCENARIO_AB = (
  <>
    The number of activated sites in the country has been updated. The Activation Profiles 
    section will be reset to the default for the updated number of sites. If you made any 
    changes in the Activation Profiles section, please review the defaults for the updated 
    number of sites and update again if needed.
    <br /><br />
    Clicking Cancel will void the update to the number of sites in the country.
    <br /><br />
    Clicking OK will retain the update to the number of sites in the country and reset the 
    Activation Profiles section to the default for the updated number of sites.
  </>
);

export const ACTIVATION_PROFILES_WARNING_MESSAGE_UPLOAD = (
  <>
    The number of activated sites in the Country Inputs section of the uploader template has been updated. 
    The Activation Profiles section will be reset to the default for the updated number of sites. If you 
    made any changes in the Activation Profiles section, please review the defaults for the updated number 
    of sites and update again if needed.
    <br /><br />
    Clicking Cancel will void the update to the number of sites in the country and cancels the upload.
    <br /><br />
    Clicking OK will retain the update to the number of sites in the Country Inputs section of the uploader 
    template and reset the Activation Profiles section to the default for the updated number of sites when 
    the file is uploaded.
  </>
);

export const SOE_DELETE_WARNING_MESSAGE = (elementName, visitOrAssessment = "visit") => (
  <>
    Are you sure you want to delete the {visitOrAssessment} <strong>{elementName}</strong>? This cannot be 
    undone and will permanently delete this {visitOrAssessment} at the study, country and site levels. 
  </>
);

export const UPLOAD_COST_MODAL_WARNING_MESSAGE = (countries) => (
  <>
    There are existing costs in countries: <strong>{countries.join(", ")}</strong>. Uploading a new budget template will overwrite the costs in these countries.
  </>
);

export const UPLOAD_SOE_TABLE_WARNING_MESSAGE = (
  <>
    There are existing data in the SOE table. Clicking Upload will overwrite the visit/assessment indicators in the table.
  </>
);